module.exports = __webpack_public_path__ + "img/app.dc8b94a5.png";